<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单号</label>
            <em class="weui-form-preview__value">{{ form.main.eqc_code }}</em>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">基础信息</div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">设备编号</label>
            <span class="weui-form-preview__value">{{
              form.main.eqc_eqcode
            }}</span>
          </div>
          <change-field
            label="设备名称"
            :old-value="form.main.eqc_name_old"
            :new-value="form.main.eqc_name_new"
          />
          <change-field
            label="规格型号"
            :old-value="form.main.pr_spec_old"
            :new-value="form.main.pr_spec_new"
          />
          <change-field
            label="品牌"
            :old-value="form.main.eqc_brand_old"
            :new-value="form.main.eqc_brand_new"
          />
          <change-field
            label="设备类别"
            :old-value="form.main.eqc_kind_old"
            :new-value="form.main.eqc_kind_new"
          />
          <change-field
            label="检查周期"
            :old-value="form.main.eqc_check_time_old + parseManuType(form.main.eqc_check_period_old)"
            :new-value="form.main.eqc_check_time_new + parseManuType(form.main.eqc_check_period_new)"
          />
          <change-field
            label="设备状态"
            :old-value="form.main.eqc_state_old"
            :new-value="form.main.eqc_state_new"
          />
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">变更信息</div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更人</label>
            <span class="weui-form-preview__value">{{
              form.main.updaterName
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.updateTime
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">审核人</label>
            <span class="weui-form-preview__value">{{
              form.main.eqc_auditman
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">审核日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.eqc_auditdate
            }}</span>
          </div>
           <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更原因</label>
            <span class="weui-form-preview__value">{{
              form.main.eqc_reason
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChangeField from "@/components/field/ChangeField";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  components: {
    ChangeField,
  },
  data() {
    return {
      baseUrl: "/api/oa/equipmentChange",
    };
  },
  methods: {
    parseManuType(type) {
      return { year: "年", month: "月", week: "周" ,day:"日"}[type];
    },
  },
};
</script>